interface CarouselItem {
  image: string;
  title: string;
  tag: string;
  desc: string;
  date: string;
}

const carouselItems: CarouselItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20red%20carpet%20event%20with%20flashing%20cameras%20and%20celebrities%2C%20Chinese%20entertainment%20news%20photography%2C%20luxurious%20evening%20atmosphere%2C%20warm%20golden%20lighting%2C%20editorial%20style%2C%20glamorous%20composition&width=720&height=480&seq=carousel-01&orientation=landscape',
    title: '娱乐圈年度十大爆料事件深度回顾',
    tag: '年度盘点',
    desc: '从顶流塌房到综艺争议，回顾今年娱乐圈最令人震惊的十大事件，每一个都曾引发全网热议。',
    date: '2026-07-28',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20studio%20setup%20with%20professional%20cameras%20and%20lighting%20equipment%20during%20a%20live%20streaming%20session%2C%20behind%20the%20scenes%20of%20internet%20broadcasting%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%20atmosphere&width=720&height=480&seq=carousel-02&orientation=landscape',
    title: '网红经济大起底：流量背后的真相',
    tag: '深度调查',
    desc: '揭秘网红圈不为人知的运作模式，从数据造假到MCN机构操作，还原流量背后的真实生态。',
    date: '2026-07-25',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20courtroom%20or%20legal%20setting%20with%20documents%20and%20gavel%2C%20dramatic%20lighting%20through%20windows%2C%20Chinese%20legal%20drama%20aesthetic%2C%20serious%20atmosphere%2C%20editorial%20photography%20style&width=720&height=480&seq=carousel-03&orientation=landscape',
    title: '演艺圈解约纠纷全解析：谁是谁非',
    tag: '法律视角',
    desc: '多起艺人解约事件背后隐藏的合同陷阱、利益博弈与法律争议，专业人士逐案分析。',
    date: '2026-07-22',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20feeds%20displayed%20on%20multiple%20smartphone%20screens%2C%20Chinese%20social%20platforms%20interface%2C%20trending%20topics%20concept%2C%20warm%20tech%20lifestyle%20photography%2C%20clean%20modern%20aesthetic&width=720&height=480&seq=carousel-04&orientation=landscape',
    title: '热搜背后的隐形推手：谁在操控舆论',
    tag: '独家揭秘',
    desc: '深入调查热搜榜单背后的水军产业链、数据操纵手段以及平台算法的运作逻辑。',
    date: '2026-07-18',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20of%20a%20movie%20set%20with%20cameras%2C%20lights%20and%20crew%20members%20working%2C%20Chinese%20film%20industry%20behind%20the%20scenes%2C%20warm%20professional%20lighting%2C%20authentic%20documentary%20style&width=720&height=480&seq=carousel-05&orientation=landscape',
    title: '影视圈选角黑幕：那些年被截胡的角色',
    tag: '圈内爆料',
    desc: '多位业内人士匿名揭发影视项目选角过程中的暗箱操作与利益输送，揭开行业遮羞布。',
    date: '2026-07-15',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20gossip%20magazines%20and%20news%20screenshots%20arranged%20artistically%2C%20Chinese%20tabloid%20aesthetic%2C%20warm%20vintage%20tones%2C%20editorial%20collage%20composition%2C%20nostalgic%20yet%20modern%20feel&width=720&height=480&seq=carousel-06&orientation=landscape',
    title: '吃瓜文化变迁史：从街头小报到网络爆料',
    tag: '文化观察',
    desc: '回顾中国人"吃瓜"文化的演变历程，从传统媒体时代到新媒体时代的爆料生态全景。',
    date: '2026-07-10',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            深度聚焦近期最受关注的热点事件
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer"
            >
              {/* Image */}
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-primary-500 text-background-50">
                    {item.tag}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-4">
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mb-3 line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {item.date}
                  </span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}